module.exports = __webpack_public_path__ + "static/media/factory_setup_darkmode.d9e36e3c.svg";